import { useState } from 'react';
import { history } from 'Store';
import useTranslation from 'Hooks/useTranslation';
import Arrow from 'Components/icons/Arrow';
import { slideBack } from 'Styles/utils/utils';
import { routes } from 'Constants/routes';
import { AccountContentProps } from './types';
import * as Styled from './styles';

const AccountContent = ({
  id,
  screen,
  contentScreens,
  isSubContent,
}: AccountContentProps): JSX.Element => {
  const { t } = useTranslation();
  const [isSubContentSet, setIsSubContentSet] = useState(isSubContent);
  const ScreenComponent = contentScreens[screen];

  return (
    <Styled.Container id={id}>
      <Styled.BackButton
        onClick={() => {
          slideBack(`#${id}`);
          history.replace(routes.ACCOUNT);
        }}
        isSubContent={isSubContentSet}
      >
        <Arrow />
        {t('common:BackButton')}
      </Styled.BackButton>
      {ScreenComponent && <ScreenComponent setSubContent={setIsSubContentSet} />}
    </Styled.Container>
  );
};

export default AccountContent;
